export default {
	GET_ALL: (crewId) => `/recipe/all?crewId=${crewId}`,
	GET_BY_ID: (id) => `/recipe/${id}`,
	GET_SHARED: (shareToken) => `/recipe/share/${shareToken}`,
	CREATE: (crewId) => `/recipe?crewId=${crewId}`,
	UPDATE: () => "/recipe",
	DELETE: (id) => `/recipe/${id}`,
	SHARE: (id) => `/recipe/${id}/share`,
};
